import { createAdUnitCode } from "./create-ad-unit-code";

export const callVideoPlayerAdUnit = () => {
	/**
		 * Creates a Google tagless request, independent of GPT slots.
		 */

	//remove the existing script if it exists from a previous page
	const existingVideoPlayerScript = document.getElementById('videoPlayerAdUnitScript');
	if (existingVideoPlayerScript != null) {
		existingVideoPlayerScript.remove();
	}

	const adUnitCode = createAdUnitCode('video_player');

	//set additional params and targeting values
	const cacheBuster = Date.now();
	const adInfoStr = encodeURIComponent(
		new URLSearchParams(window.adInfo).toString(),
	);
	const { ppid } = window.globalAdConfig;
	const { userid3p } = window.adInfo;

	//add the tagless request to the head
	const scriptUrl = `https://securepubads.g.doubleclick.net/gampad/adx?iu=${adUnitCode}&sz=3x3&c=${cacheBuster}&m=text/javascript&t=${adInfoStr}&ppid=${ppid}&userid3p=${userid3p}`;
	const scriptEl = document.createElement('script');
	scriptEl.src = scriptUrl;
	scriptEl.id = "videoPlayerAdUnitScript";
	scriptEl.async = true;
	document.head.appendChild(scriptEl);
};
